import { render, staticRenderFns } from "./SlideDeckResourceList.vue?vue&type=template&id=132b3af9"
import script from "./SlideDeckResourceList.vue?vue&type=script&lang=ts"
export * from "./SlideDeckResourceList.vue?vue&type=script&lang=ts"
import style0 from "./SlideDeckResourceList.vue?vue&type=style&index=0&id=132b3af9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports